import React from 'react';
import { getItemEligibilityLabel } from '../../../utils/bookingItemEligibility';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { Box } from '@mui/system';
import DraggableDataGrid from '../draggableDataGrid';
import { DragIndicator } from '@mui/icons-material';
import toast from 'react-hot-toast';
import axios from '../../../../axios';
import { REORDER_ITEMS } from '../../../api';


function ItemViewPackage({ open, handleClose, data, getServicesData }) {
    const handleListUpdate = (newOrderedList) => {
        if (newOrderedList?.length) {
            const formattedList = newOrderedList.map((z) => {
              return {
                item_id: z?.id,
                order: z?.order,
              };
            });
            toast.promise(
              axios.put(`${REORDER_ITEMS}/${data?.id}/`, formattedList, {
                headers: { 'Content-Type': 'application/json' },
              }),
              {
                loading: () => {
                  return `Updating Order!`;
                },
                success: (res) => {
                    getServicesData();
                  return res?.data?.message;
                },
                error: (err) => {
                  return err?.message;
                },
              }
            );
          }
    };

    return (
        <Dialog
            open={open}
            onClose={() => {
                handleClose();
            }}
            maxWidth={'md'}
            fullWidth
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogContent>
                <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                    <h2>Item Title :- </h2>
                    <h3>{data?.title}</h3>
                </div>

                {/* Use DraggableDataGrid instead of the plain table */}
                <DraggableDataGrid
                    data={data?.item?.slice()?.sort((a, b) => a.order - b.order) || []}
                    columns={[
                        { field: 'title', headerName: 'Title', width: '20%' },
                        { field: 'price', headerName: 'Price', width: '10%' },
                        { field: 'package', headerName: 'Package', width: '10%' },
                        {
                            field: 'eligibility_type',
                            headerName: 'Eligibility',
                            width: '20%',
                            sortable: false,
                            renderCell: ({ value }) => getItemEligibilityLabel(value),
                        },
                        {
                            field: 'discount_value',
                            headerName: 'Discount',
                            width: '12%',
                            renderCell: ({ row }) => {
                                const value = row?.discount_value ?? row?.discount_amount ?? row?.discount_percent ?? 0;
                                return row?.discount_type === 'fixed' ? `$${value}` : `${value}%`;
                            },
                        },
                        { field: 'time_hrs', headerName: 'Time Hours', width: '12%' },
                        {
                            field: 'order',
                            headerName: 'Item Order',
                            width: '16%',
                            renderCell: ({ value, row, index }) => (
                                <Box display="flex" alignItems="center">
                                    {value}
                                    <DragIndicator style={{ cursor: 'move', marginRight: '8px' }} />
                                </Box>
                            ),
                        },]}
                    onListUpdate={handleListUpdate}
                />
                {/* <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                    <h2>Item Title :- </h2>
                    <h3>{data?.title}</h3>
                </div>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr>
                            <th style={{ padding: '12px', textAlign: 'center', border: '1px solid #ddd', backgroundColor: '#f2f2f2' }}>Title</th>
                            <th style={{ padding: '12px', textAlign: 'center', border: '1px solid #ddd', backgroundColor: '#f2f2f2' }}>Price</th>
                            <th style={{ padding: '12px', textAlign: 'center', border: '1px solid #ddd', backgroundColor: '#f2f2f2' }}>Package</th>
                            <th style={{ padding: '12px', textAlign: 'center', border: '1px solid #ddd', backgroundColor: '#f2f2f2' }}>Discount Percent</th>
                            <th style={{ padding: '12px', textAlign: 'center', border: '1px solid #ddd', backgroundColor: '#f2f2f2' }}>Time Hours</th>
                            <th style={{ padding: '12px', textAlign: 'center', border: '1px solid #ddd', backgroundColor: '#f2f2f2' }}>Item Order</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data?.item ? (
                            data.item.map((packageItem, index) => (
                                <tr key={index}>
                                    <td style={{ padding: '12px', textAlign: 'center', border: '1px solid #ddd' }}>{packageItem.title}</td>
                                    <td style={{ padding: '12px', textAlign: 'center', border: '1px solid #ddd' }}>{packageItem.price}</td>
                                    <td style={{ padding: '12px', textAlign: 'center', border: '1px solid #ddd' }}>{packageItem.package}</td>
                                    <td style={{ padding: '12px', textAlign: 'center', border: '1px solid #ddd' }}>{packageItem.discount_percent}</td>
                                    <td style={{ padding: '12px', textAlign: 'center', border: '1px solid #ddd' }}>{packageItem.time_hrs}</td>
                                    <td style={{ padding: '12px', textAlign: 'center', border: '1px solid #ddd' }}>{packageItem.order
                                    }</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="5" style={{ textAlign: 'center' }}>No data available</td>
                            </tr>
                        )}
                    </tbody>
                </table> */}
                <Box display={'flex'} alignItems="center" justifyContent={'end'} sx={{ mb: 2, mt: 3 }}>
                    <Button
                        onClick={() => {
                            handleClose();
                        }}
                        variant="outlined"
                        color="primary"
                        sx={{ mr: 2 }}
                    >
                        Close
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
}

export default ItemViewPackage;
